import "invokers-polyfill";
import "dialog-closedby-polyfill";
import "chartkick/chart.js";
import "../pwa";

// Lexxy editor loaded via Sprockets (gem provides assets)

require("@hotwired/turbo-rails");
// require("channels")

require("stylesheets/application.css");

import "controllers";

// Rails engine for cache-friendly, client-side local time
// https://github.com/basecamp/local_time
import LocalTime from "local-time";
LocalTime.config.i18n["en"] = {
  date: {
    dayNames: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    abbrDayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    monthNames: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    abbrMonthNames: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    yesterday: "yesterday",
    today: "today",
    tomorrow: "tomorrow",
    on: "on {date}",
    formats: {
      default: "%b %e, %y",
      thisYear: "%b %e",
    },
  },
  time: {
    am: "am",
    pm: "pm",
    singular: "a {time}",
    singularAn: "an {time}",
    elapsed: "{time} ago",
    second: "second",
    seconds: "seconds",
    minute: "minute",
    minutes: "minutes",
    hour: "hour",
    hours: "hours",
    formats: {
      default: "%l:%M%P",
    },
  },
  datetime: {
    at: "{date} at {time}",
    formats: {
      default: "%B %e, %Y at %l:%M%P %Z",
    },
  },
};
LocalTime.config.locale = "en";
LocalTime.start();
// A refresh morph patches <time> in place and drops data-localized; LocalTime only watches inserted nodes.
document.addEventListener("turbo:morph", () => LocalTime.run());

// Float labels on .input-control fields that have a value
document.addEventListener("turbo:render", function () {
  document.querySelectorAll(".input-control").forEach(function (el) {
    if (el.value) el.classList.add("active");
  });
});

document.addEventListener("change", function (e) {
  if (e.target.classList.contains("input-control")) {
    e.target.classList.toggle("active", e.target.value !== "");
  }
});
